/* eslint-disable max-len */
import { createSvgIcon } from '@mui/material/utils';

export default createSvgIcon(
  <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 6.7c1.9 0 3.3 1.5 3.3 3.3H14c0-1.1-1-2-2-2V8.7zm5.4 9.4C11 18.1 5.9 13 5.9 6.6c0-.4.3-.7.7-.7H9c.4 0 .7.3.7.7-.1.8 0 1.6.3 2.4.1.2 0 .5-.2.7l-1.1 1.1c1 1.9 2.6 3.5 4.5 4.5l1.1-1.1c.2-.2.5-.3.7-.2.8.3 1.5.4 2.4.4.4 0 .7.3.7.7l.1 2.5c-.1.2-.4.5-.8.5zm-.6-6.1c0-2.6-2.1-4.8-4.8-4.8V5.9c3.3 0 6.1 2.7 6.1 6.1h-1.3z"/>
, 'PhoneInTalk');
